import { render, staticRenderFns } from "./GeneralDeleteMessage.vue?vue&type=template&id=437a452e&"
import script from "./GeneralDeleteMessage.vue?vue&type=script&lang=js&"
export * from "./GeneralDeleteMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports